import styled from 'styled-components';

export const ModalWrapper = styled.section`
  height: 100%;
`;